import React, {useState} from 'react';

import Header from 'modules/header/wholesaler/main';
import MyAdvertisment from 'modules/myAdvertisment/myAdvertisment';
import ADSwitchButton from './ADSwitch';

const MyAdvertismentContainer = () => {
  const [isSaleAD, setisSaleAD] = useState<boolean>(false);

  return (
    <div className="w-full h-full">
      <Header title={'آگهی های من'} />
      <div className="w-full h-full flex flex-col gap-2 my-2 relative">
        <ADSwitchButton isSaleAD={isSaleAD} setisSaleAD={setisSaleAD} />
        <MyAdvertisment isSaleAD={isSaleAD} app={'wholesaler'} />
      </div>
    </div>
  );
};

export default MyAdvertismentContainer;
